import React from "react";
import * as Phosphor from "@phosphor-icons/react";
import { api, formatPHP } from "../lib/api";

export default function Services() {
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    api.get("/services").then((r) => setItems((r.data || []).filter((s) => s.active !== false)));
  }, []);

  if (!items.length) return null;

  return (
    <section
      id="services"
      className="relative py-20 md:py-32 px-6 sm:px-8 md:px-10 bg-[#0A0B10]"
      data-testid="services-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="overline mb-3 md:mb-4">Curated Add-ons</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
            Other <span className="italic text-[#C5A059]">Services</span>
          </h2>
          <div className="gold-divider mt-6 md:mt-8 mx-auto" />
          <p className="text-[#A1A4B5] mt-6 md:mt-8 max-w-xl mx-auto leading-relaxed text-sm sm:text-base">
            Elevate your stay with our curated selection of in-villa experiences and add-ons.
            Just message us to arrange any of these alongside your booking.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border)] border border-[var(--border)] rounded-2xl overflow-hidden">
          {items.map((s) => {
            const Icon = Phosphor[s.icon] || Phosphor.Sparkle;
            const priceDisplay =
              Number(s.price) > 0
                ? `${(s.price_note || "").trim()} ${formatPHP(s.price)}`.trim()
                : "Inquire";
            return (
              <div
                key={s.id}
                className="bg-[#0A0B10] p-6 sm:p-7 group hover:bg-[#13151D] transition-colors"
                data-testid={`service-card-${s.id}`}
              >
                <Icon
                  size={26}
                  weight="thin"
                  className="text-[#C5A059] group-hover:scale-110 transition-transform"
                />
                <h4 className="font-serif-display text-lg sm:text-xl mt-3 sm:mt-4">{s.name}</h4>
                {s.description && (
                  <p className="text-[#A1A4B5] text-xs sm:text-sm mt-2 leading-relaxed">
                    {s.description}
                  </p>
                )}
                <div className="text-[#C5A059] text-sm font-medium mt-4">
                  {priceDisplay}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
